import { useEffect, useState } from 'react';
import { Link2, ExternalLink } from 'lucide-react';
import { useClientAuth } from '../context/ClientAuthContext';
import { clientAuthConfig } from '../utils/clientAuthConfig';
import api from '../services/api';
import './ClientPortal.css';

export default function ClientResourcesPage() {
  const { client, agentSlug } = useClientAuth();
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (!agentSlug) return;
    api.get('/clients/me/resources', clientAuthConfig(agentSlug))
      .then((res) => {
        setResources(res.data?.resources || []);
        setLoadError(false);
      })
      .catch(() => setLoadError(true))
      .finally(() => setLoading(false));
  }, [agentSlug]);

  return (
    <div className="client-portal-page">
      <header className="client-portal-page__header">
        <h1>Resources</h1>
        <p>Links and guides {client?.agent?.first_name || 'your agent'} has put together for you.</p>
      </header>

      <section className="client-portal__panel">
        {loading ? (
          <p className="client-portal__panel-desc">Loading…</p>
        ) : loadError ? (
          <p className="client-form__error">Couldn&apos;t load resources. Refresh the page to try again.</p>
        ) : resources.length === 0 ? (
          <p className="client-portal__panel-desc">
            <Link2 size={14} style={{ verticalAlign: '-2px', marginRight: 6, opacity: 0.6 }} />
            Nothing here yet — {client?.agent?.first_name || 'your agent'} hasn't added any resources.
          </p>
        ) : (
          <div className="client-resources-list">
            {resources.map((r) => (
              <a
                key={r.id}
                href={r.url}
                target="_blank"
                rel="noopener noreferrer"
                className="client-resource-card"
              >
                <div className="client-resource-card__title">
                  {r.title}
                  <ExternalLink size={13} />
                </div>
                {r.description && (
                  <div className="client-resource-card__description">{r.description}</div>
                )}
              </a>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
